<template>
  <div v-if="data">
    <Tabs v-model="data.current" :animated="false">
      <template v-for="(item) in data.coms" >
        <TabPane :name="item.title" :label="item.title" v-if="p(item.p)" :key="item.title">
          <component :is="item.component"></component>
        </TabPane>
      </template>

      <!-- <TabPane name="2" label="物品档案管理" v-if="p('archives/list')">
        <c2></c2>
      </TabPane>
      <TabPane name="3" label="供应商管理" v-if="p('supplier/list')">
        <c3></c3>
      </TabPane>-->
    </Tabs>
  </div>
</template>
<script>
import { mixin } from "../../mixin";
export default {
      mixins: [mixin],
  name: "MultTab",
  props: {
    data: {
      type: Object,
      default: null
    }
  },
};
</script>